const MAX_TITLE = 80;

/** Title for an exported report: first markdown heading, else first non-empty
    line, trimmed to 80 chars; "דוח" if nothing usable. */
export function deriveReportTitle(markdown: string): string {
  const lines = (markdown || '').split('\n');
  const heading = lines.find((l) => /^#{1,3}\s+/.test(l.trim()));
  const raw = heading
    ? heading.trim().replace(/^#{1,3}\s+/, '').trim()
    : (lines.find((l) => l.trim().length > 0) || '').trim();
  const title = raw.slice(0, MAX_TITLE);
  return title || 'דוח';
}

/** True if the markdown contains a GFM table (header row + separator row). */
export function hasMarkdownTable(markdown: string): boolean {
  const lines = (markdown || '').split('\n');
  const sep = /^\s*\|?\s*:?-{2,}:?\s*(\|\s*:?-{2,}:?\s*)+\|?\s*$/;
  return lines.some((l, i) => l.includes('|') && i + 1 < lines.length && sep.test(lines[i + 1]));
}
